import React from 'react';
import { FileUp } from 'lucide-react';

const formatTimestamp = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown time';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
};

const CorporateProjectSourceStage = ({
  busy,
  citations,
  editable,
  extraction,
  fileRef,
  isPdfSource,
  onOpenPdf,
  onUpload,
  project,
  projectId
}) => (
  <section className="forecast-panel workspace-stage-panel" id="project-stage-source" tabIndex="-1">
    <div className="forecast-panel-head">
      <span className="forecast-section-code">PRJ_01 ● Business case intake</span>
      <h2>Upload the business case that grounds every project assumption</h2>
    </div>
    <div className="forecast-submit-chips" aria-live="polite">
      <input
        ref={fileRef}
        type="file"
        accept=".pdf,.docx,.xlsx"
        style={{ display: 'none' }}
        onChange={(event) => onUpload(event.target.files?.[0])}
      />
      <button
        type="button"
        className="forecast-primary-button"
        disabled={busy === 'upload' || !editable}
        onClick={() => fileRef.current?.click()}
      >
        <FileUp size={15} aria-hidden="true" />
        {busy === 'upload' ? 'Extracting…' : project.source_doc_name ? 'Replace source' : 'Upload PDF / DOCX / XLSX'}
      </button>
      {project.source_doc_name && (
        <span className="forecast-health-chip neutral">Source: {project.source_doc_name}</span>
      )}
      {project.source_doc_name && !isPdfSource && (
        <a
          className="forecast-secondary-button compact"
          href={`/api/regional-forecast/projects/${projectId}/document`}
          target="_blank"
          rel="noreferrer"
        >
          Open source document
        </a>
      )}
      {isPdfSource && extraction && (
        <button type="button" className="forecast-secondary-button compact" onClick={onOpenPdf}>
          See &amp; verify in PDF ({citations.length} cited figures)
        </button>
      )}
      {extraction && <span className="forecast-health-chip moss">Extraction ready</span>}
      {extraction?.extractedAt && (
        <span className="forecast-health-chip neutral">
          Extracted {formatTimestamp(extraction.extractedAt)}
        </span>
      )}
    </div>
    <p className="forecast-submit-note">
      Accepted formats: PDF, DOCX, and XLSX. Replacing the source requires the extraction and spread to be reviewed again.
    </p>
  </section>
);

export default CorporateProjectSourceStage;
